// extracted by mini-css-extract-plugin
export default {"scrollable_menu":"scrollableMenu_scrollable_menu__pW1MI","scrollable_menu_container":"scrollableMenu_scrollable_menu_container__04P1+"};